import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-surface text-center text-foreground" aria-label="Limited time offer" data-id="element-236" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgb(var(--color-primary)/0.8)]" aria-hidden="true" data-id="element-237" data-mp="36bimjig91jdv" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-238" data-mp="31hxvkad2ppo6">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-primary-strong" data-id="element-239" data-mp="3g7c81rby4n7s">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="3b893s93sil0v" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-241" data-mp="3p8a49ng57qft" />
        <p className="mt-7 font-bold text-foreground" data-id="element-242" data-mp="3l78eryc12sr1">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-primary shadow-[0_0_16px_rgb(var(--color-primary)/0.8)]" aria-hidden="true" data-id="element-243" data-mp="1uu97d845ldid" />
    </section>;
}